import Vue from "vue";
import App from "./App.vue";
import Vuex from "vuex";
import Vuetify from "vuetify";
import Axios from "./plugins/axios.js";
import "vuetify/dist/vuetify.min.css";
import { firestorePlugin } from "vuefire";
import router from "./router";
import store from "./store";
import "./registerServiceWorker";
import { sync } from "vuex-router-sync";
import "@mdi/font/css/materialdesignicons.css";
const fb = require("./firebaseConfig.js");

Vue.config.productionTip = false;

Vue.use(Vuex);
Vue.use(firestorePlugin);
sync(store, router);

Vue.use(Vuetify, {
  iconfont: "mdi"
});

Vue.use(Axios);

// handle page reload
fb.auth.onAuthStateChanged(user => {
  if (user) {
    store.commit("setCurrentUser", user);
    store.dispatch("fetchUserProfile");

    fb.usersCollection.doc(user.uid).onSnapshot(doc => {
      store.commit("setUserProfile", doc.data());
    });
  }
});

let app;
fb.auth.onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      el: "#app",
      router,
      store,
      vuetify: new Vuetify(),
      render: h => h(App)
    });
  }
});
